import axios from 'core/axiosInstance';
import rootService from 'core/services.root';
const fileDownload = require('js-file-download');

export default rootService({
    deleteFile: ['DELETE', '/file/delete/:file_id'],
    deleteFolder: ['DELETE', '/folder/delete/:folder_id'],
    fetchFile: ['GET', '/file/:file_id'],
    fetchFolders: ['GET', '/folder/patient/:patient_id'],
    postFile: ['POST', '/file/store', { headers: { 'content-type': 'multipart/form-data' } }],
    postFolder: ['POST', '/folder/store'],
    putFile: ['PUT', '/file/update/:id'],
    putFolder: ['PUT', '/folder/update/:id']
});

export const downloadFileService = async (id, name) => {
    const url = `/file/download/${ id }`;
    const data = await axios.get(url, { responseType: 'blob' });
    const { data: file } = data;
    fileDownload(file, name);
};
